import request from '../utils'

const modelingApi = {
    modelingList: async () => {
        const req = request.get(`/api/modeling`)
        const res = await req;
        return res.body;
    },
    modelingDetail: async (modeling) => {
        const req = request.get(`/api/modeling/${modeling}`)
        const res = await req;
        return res.body;
    },
    modelingUpdate: async (modeling) => {
        const req = request.put(`/api/modeling/${modeling.id}`).send(modeling);
        const res = await req;
        return res.body;
    },
    modelingCreate: async (modeling) => {
        const req = request.post(`/api/modeling`).send(modeling);
        const res = await req;
        return res.body;
    },
    modelingDelete: async (modelingId) => {
        const req = request.delete(`/api/modeling/${modelingId}`);
        await req;
    },
    modelingExport: (modelingId) => {
        const req = request.get(`/api/modeling/${modelingId}/json`);
        return req;
    },
    modelingInfo: async (modeling) => {
        const req = request.get(`/api/modeling/info/${modeling}`)
        const res = await req;
        return res.body;
    },
    importJson: async (modelingId, data) => {
        const req = request.post(`/api/modeling/${modelingId}/json`).send(data);
        const res = await req;
        return res.body;
    },
};

export default modelingApi